// <details> is the accessible choice for the navbar dropdown - tabbable and
// toggled by Enter and Space - but natively it only closes via its own summary.
// These listeners add the outside-click and Escape behaviour people expect.
export function initUserMenu() {
  const menu = document.getElementById('user-menu');
  if (!menu) return;

  const close = () => menu.removeAttribute('open');

  document.addEventListener('click', (event) => {
    if (!menu.contains(event.target)) close();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || !menu.hasAttribute('open')) return;
    close();
    menu.querySelector('summary')?.focus();
  });

  // A menu item either navigates or opens a dialog; either way the panel should
  // not stay open behind it.
  menu.querySelector('.dropdown-content')?.addEventListener('click', close);
}
